import React from "react";
import Styles from './styles.module.scss';

import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const LaunchpadProjectsAll = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const projectsLast = useSelector(store => store.cabinet.projectsLast);


    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.titleRow}`}>
                    <div className={`${Styles.titleRowName}`}>{t('Последние проекты')}</div>
                </div>
                <div className={`${Styles.contentBox}`}>
                    {projectsLast?.projects?.length > 0 ? projectsLast?.projects?.map((item, index)=>{
                        return (
                            <div className={`${Styles.contentBoxItem}`} onClick={()=>{navigate(`/projects/${item.slug}`)}}>
                                <img src={item.logo} alt={item.description?.title} />
                                {/*<div className={`${Styles.contentBoxItemName}`}>{item.description?.title}</div>*/}
                            </div>
                        )
                    }) : null}
                    <div className={`${Styles.btn}`} onClick={()=>{navigate('/projects')}}>{t('Все')}<br/>{t('Проекты')}</div>
                </div>
            </div>
        </section>
    );
};

export default LaunchpadProjectsAll;